import deepmerge from 'deepmerge';
import {v4 as uuid} from 'uuid';

import log from '../services/logger/log';

const guid = () => uuid();

const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

const mergeDeep = (target, source) => deepmerge(target, source, {arrayMerge: overwriteMerge});

const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const runFunction = (func, ...args) => {
    if (typeof func === 'function') {
        return args ? func(...args) : func();
    }
};

const scrollTop = (y = 0) => {
    window.document.body.scrollTop = y; // For useIOSSafariFixes
    window.scrollTo({top: y});
};

export const parseJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        return JSON.parse(jsonPayload);
    } catch (e) {
        log.error(`Error parse jwt: ${e}`, e);
    }
};

const withRetry = async (func, {retries = 3, delay = 1000, stopError, onRetry} = {}) => {
    let attempt = 0;

    while (attempt < retries) {
        try {
            return await func();
        } catch (e) {
            if (stopError && e instanceof stopError) throw e;

            attempt++;

            onRetry?.({attempt, retries, error: e});

            if (attempt >= retries) throw e;

            await timeout(delay);
        }
    }
};

const disallowParallelExecution = (func) => {
    let promise = null;

    return (...args) => {
        if (promise) return promise;

        promise = func(...args).finally(() => {
            promise = null;
        });

        return promise;
    };
};

const throttle = (func, delay) => {
    let lastCall = 0;

    return (...args) => {
        const now = Date.now();

        if (now - lastCall < delay) return;

        lastCall = now;
        return func(...args);
    };
};

export default {
    guid,
    mergeDeep,
    timeout,
    runFunction,
    scrollTop,
    parseJwt,
    withRetry,
    disallowParallelExecution,
    throttle,
};
